import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function FAQ() {

  const { t } = useTranslation();

  function goBackHome() {
    window.history.go(-1)
  }

  return (
    <div className="fnFormScroll">
      <div className="page-scrollbar">
        <div class="container_90">
          <div>
            <div class="text-center">
              <div class="top_green_bg">
                <div class="top_green_bg_return font_14_500" onClick={goBackHome}>返回首頁</div>
                <div class="text-center">
                  <div class="top_green_bg_green_font "></div>
                  <div class="top_green_bg_white_font28"></div>
                  <div class="top_green_bg_white_font24">Q&A</div>
                </div>
              </div>

              {/* <!--智能客服--> */}
              {/* <a href="https://cai.gss.com.tw/webchat/index.html?botid=aics_moeaic"
                target="_blank"
                title="另開視窗_連結至智能客服">
                <div alt="" class="fly robot" />
              </a> */}

              <div class="form_white_box">
                {/* 1 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">1、 自然人憑證相關問題</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <ul>
                                <li>
                                  <a target="_blank" href="https://moica.nat.gov.tw/faq_in_c_18_1.html">本國人憑證問題集</a>
                                </li>
                                <li>
                                  <a target="_blank" href="https://moica.nat.gov.tw/other/faq_in_14f98003b99000000a19.html">外國人憑證問題集</a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 2 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">2、 投資審議專屬憑證申請資格</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ol>
                        <li>自然人：年滿18歲以上，且未受監護宣告者。</li>
                        <li>公司、社團或財團法人：依中華民國法律或外國法律組織成立者。</li>
                      </ol>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 3 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">3、 如何申請投資審議專屬憑證？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >
                                請填妥「經濟部投資審議司專屬憑證申請單」，並備妥相關文件，臨櫃投資審議司辦理申請；並於收到申請通知信後，完成憑證申請作業。
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 4 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">4、 辦理投資審議專屬憑證需要費用嗎？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <p >申請投資審議專屬硬體憑證用戶，需匯款支付晶片卡工本費用500元，銀行匯款 / ATM轉帳資訊如下 :</p>
                            <ul>
                              <li>戶名：臺灣網路認證股份有限公司</li>
                              <li>銀行代碼：807永豐商業銀行</li>
                            </ul>
                            <ol >
                              <li>公司、社團或財團法⼈申請匯款帳號：永豐商業銀行城中分行324000+貴公司統一編號（共十四碼）</li>
                              <li>自然人申請匯款帳號：永豐商業銀行城中分行126-001-0015069-7</li>
                            </ol>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 5 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">5、 投資審議專屬憑證效期多久？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >投資審議專屬憑證有效期間為一年，請於到期前進行展延；逾期後需重新申請。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 6 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">6、 遺失或忘記投資審議專屬憑證密碼，怎麼辦？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請重新登入憑證小幫手，並點選「軟體憑證匯出匯入」，將軟體憑證匯出PFX檔案，即可再次取得投資審議專屬憑證。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 7 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">7、 TWCA憑證小幫手如何下載？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p>
                                請至網站<a href="https://www.twca.com.tw/downloadArea" target="_blank" title="另開視窗_連結至TWCA下載專區"> TWCA下載專區 </a>，點選「工具」並下載安裝「TWCA憑證小幫手」，憑證小幫手支援的作業系統為：Windows 10(含)以上，請以系統管理員權限開啟安裝檔，安裝精靈會把憑證小幫手安裝至您的電腦中。
                              </p>
                              <p>TWCA憑證小幫手操作說明請參閱
                                <a href="https://cloudra.twca.com.tw/aspraCore/files/twcacerthelp/twcacerthelper.html" target="_blank" title="另開視窗_連結至TWCA憑證小幫手操作說明"> TWCA憑證小幫手操作說明書 </a></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 8 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">8、 如何檢視憑證？查看憑證效期？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請登入憑證小幫手，並點選「檢視憑證資訊」來查看您擁有之憑證主旨名稱和使用期限。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 9 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">9、 投資審議專屬憑證晶片卡密碼鎖住了怎麼辦？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請登入憑證小幫手，並點選「卡片解鎖」，重新驗證並設定卡片密碼。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 10 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">10、 如何變更憑證小幫手之密碼？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請登入憑證小幫手，並點選「帳號密碼變更」重新進行變更。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 11 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">11、 忘記憑證小幫手帳號的密碼怎麼辦？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請登入憑證小幫手，並點選「忘記密碼」，重新驗證並設定密碼。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 12 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">12、 如何匯出投資審議專屬軟體憑證？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請登入憑證小幫手，並點選「軟體憑證匯出匯入」，選擇「將憑證匯出成PFX檔案」並完成憑證密碼設定。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 13 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">13、 個人資料變更時，須要重新辦理嗎？要如何辦理？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請填妥「經濟部投資審議司專屬憑證申請單」，並備妥相關文件，臨櫃投資審議司辦理申請。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 14 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">14、 如何變更憑證業務或技術聯絡人？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請填妥「經濟部投資審議司專屬憑證申請單」，並備妥相關文件，臨櫃投資審議司辦理申請。或登入憑證小幫手，點選「變更聯絡人」進行線上變更資料。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 15 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">15、 如何註銷已申請之投資審議專屬憑證？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請填妥「經濟部投資審議司專屬憑證申請單」，並備妥相關文件，臨櫃或郵寄投資審議司辦理申請。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 16 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">16、 請問若有其他投資審議專屬憑證問題，該怎麼辦？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請電話洽詢本公司客服(02)2370-8886#9，將由專人協助。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                {/* 17 */}
                <Accordion className='QAlist border_bottom' id="accordionExample" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div data-bs-toggle="collapse" aria-expanded="true">
                        <div class="QATitle">17、 請問投資審議專屬憑證申請後，如何在投資審議線上申辦平台使用？</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div class="content_list_box">
                        <div class="flex_center">
                          <div class="me-auto">
                            <div class="accordion-body">
                              <p >請備妥軟體憑證/硬體憑證卡與讀卡機，並於網頁下載（憑證元件）安裝完後請重新開機，再進入線上申辦系統。</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

              </div>
              <p>{t('moea_ic.footer.issue')}<br></br>{t('moea_ic.footer.hotline')}：moea_ic_service@gss.com.tw｜{t('moea_ic.footer.hotline2')}｜{t('moea_ic.footer.serviceHour')} 9:00-17:30</p>
              < p > {t('moea_ic.footer.address')}</p>

            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
export default FAQ;